export default ".form {\n  width: 100%;\n}\n.form .full-width {\n  width: 100%;\n}"